export enum SocketChannels {
  Connection = 'connection',
  Connect = 'connect',
  Disconnect = 'disconnect',
  Jackpot = 'jackpot',
  DisconnectUser = 'disconnectUser',
  Message = 'message',
  Maintenance = 'maintenance',
  Matches = 'matches',
  Plan = 'plan',
  JackpotBanner = 'gameJackpot'
}
